import React from 'react'
import PropTypes from 'prop-types'
import { InView } from 'react-intersection-observer'

import LoaderComponent from '../LoaderComponent/LoaderComponent'

import './InfiniteListComponent.scss'

const InfiniteListComponent = ({
  children,
  direction,
  onInfiniteLoad,
  isInfiniteLoading,
  hasMoreElements,
}) => {
  const trigger = (
    <>
      <InView
        onChange={(inView) => {
          if (inView && hasMoreElements && !isInfiniteLoading) {
            onInfiniteLoad()
          }
        }}
      />
      {isInfiniteLoading && (
        <div className="loader-wrapper">
          <LoaderComponent size="small" />
        </div>
      )}
    </>
  )

  return (
    <div className="infinite-list-component">
      {direction === 'top' && trigger}
      {children}
      {direction === 'bottom' && trigger}
    </div>
  )
}

InfiniteListComponent.propTypes = {
  onInfiniteLoad: PropTypes.func.isRequired,
  isInfiniteLoading: PropTypes.bool.isRequired,
  hasMoreElements: PropTypes.bool.isRequired,
  children: PropTypes.node,
  direction: PropTypes.oneOf(['top', 'bottom']),
}

InfiniteListComponent.defaultProps = {
  direction: 'bottom',
}

// eslint-disable-next-line import-x/no-default-export
export default InfiniteListComponent
